import React from "react";
import { Helmet } from "react-helmet";

import BannerCnpAssurance from "components/CnpAssurance/BannerCnpAssurance";
import CnpAssuranceAdvice from "components/CnpAssurance/CnpAssuranceAdvice";
import CnpAssuranceAboutPartnership from "components/CnpAssurance/CnpAssuranceAboutPartnership";
import CnpAssurancePresenceInfo from "components/CnpAssurance/CnpAssurancePresenceInfo";

const CnpAssurance = () => {
    return (
        <article>
            <Helmet>
                <title>CNP Seguros Holding Brasil | Sobre a Holding</title>
                <meta name="description" content="A CNP Seguros Holding Brasil é a 3a maior seguradora do país e faz parte de um grupo com atuação global, presente em diversos países do mundo." />
                <meta name="keywords" content="CNP Seguros, Holding, seguradora, global, CNP Assurances, CNP Seguros Holding Brasil, CNP no Brasil, parceria" />
            </Helmet>
            <BannerCnpAssurance />
            <CnpAssuranceAdvice />
            <CnpAssurancePresenceInfo />
            <CnpAssuranceAboutPartnership />
        </article>
    );
};

export default CnpAssurance;